import React, { useState } from 'react';
import { FaComment, FaAddressBook, FaSpeakerDeck, FaToggleOff, FaFantasyFlightGames, FaRegWindowRestore, FaProjectDiagram } from 'react-icons/fa';
import { FaRobot } from 'react-icons/fa6';
import ChatBox from './components/ChatBox';
import ErrorLogTable from './components/ErrorLogTable';
import DesignerViewBPMNS from './components/DesignerViewBPMNS';
import BroadcastMessages from './components/BroadcastMessages';
import AxiosInstance from '../../../axiosConfig';

const AllToolsMenu = () => {
  const [showChatBox, setShowChatBox] = useState(false);
  const [showErrorLogs, setShowErrorLogs] = useState(false);
  const [errorLogs, setErrorLogs] = useState([]);
  const [showDesignerView, setDesignerView] = useState(false);
  const [showBroadCastPageView, setShowBroadCastPageView] = useState(false);

  const handleChatSimulatorClick = () => {
    setShowChatBox(true);
  };

  const handleDesignerClick = () => {
    setDesignerView(true);
  };

  const handleBroadcastClick = () => {
    setShowBroadCastPageView(true);
  };

  const handleErrorLogsClick = async () => {
    try {
      const response = await AxiosInstance.get('/get-error-log');
      if (response.data.status === 'success') {
        setErrorLogs(response.data.error_logs);
        setShowErrorLogs(true);
      } else {
        console.error('Failed to fetch error logs');
      }
    } catch (error) {
      console.error('Error fetching error logs:', error);
    }
  };

  if (showChatBox) {
    return <ChatBox onClose={() => setShowChatBox(false)} />;
  }

  if (showDesignerView) {
    return <DesignerViewBPMNS />;
  }

  if (showBroadCastPageView) {
    return <BroadcastMessages />;
  }

  if (showErrorLogs) {
    return <ErrorLogTable errorLogs={errorLogs} />;
  }

  return (
    <div className="flex w-full flex-col gap-5">
      <div className="w-full mt-3 flex h-fit flex-col gap-14 lg:grid lg:grid-cols-12">
        <div className="col-span-8 lg:grid lg:grid-cols-3 gap-4">
          {/* Customer Leads */}
          <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg">
            <FaAddressBook className="text-blue-500 text-2xl" />
            <p className="text-center mt-2">Customer Leads</p>
          </div>

          {/* Broadcast Message */}
          <div 
            className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg cursor-pointer hover:bg-gray-200 transition-colors"
            onClick={handleBroadcastClick}
          >
            <FaSpeakerDeck className="text-green-500 text-2xl" />
            <p className="text-center mt-2">BroadCast Message</p>
          </div>

          {/* Chat Simulator */}
          <div
            className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg cursor-pointer hover:bg-gray-200 transition-colors"
            onClick={handleChatSimulatorClick}
          >
            <FaComment className="text-yellow-500 text-2xl" />
            <p className="text-center mt-2">Chat Simulator</p>
          </div>

          {/* OpenAI Setup */}
          <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg hover:bg-gray-200 transition-colors">
            <FaToggleOff className="text-green-500 text-2xl" />
            <p className="text-center mt-2">OpenAI Setup</p>
          </div>

          {/* Analytics */}
          <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg hover:bg-gray-200 transition-colors">
            <FaFantasyFlightGames className="text-green-500 text-2xl" />
            <p className="text-center mt-2">Analytics</p>
          </div>

          {/* Error Logs */}
          <div
            className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg cursor-pointer hover:bg-gray-200 transition-colors"
            onClick={handleErrorLogsClick}
          >
            <FaRegWindowRestore className="text-red-500 text-2xl" />
            <p className="text-center mt-2">Error Logs</p>
          </div>

          {/* Create Bot */}
          <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg hover:bg-gray-200 transition-colors">
            <FaRobot className="text-green-500 text-2xl" />
            <p className="text-center mt-2">Create Bot</p>
          </div>

          {/* Designer */}
          <div 
            className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-lg cursor-pointer hover:bg-gray-200 transition-colors"
            onClick={handleDesignerClick}
          >
            <FaProjectDiagram className="text-purple-500 text-2xl" />
            <p className="text-center mt-2">Designer</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllToolsMenu;